
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.427.135a.527.527 0 00-.705 0 .428.428 0 000 .639l3.577 3.27H.494C.219 4.046 0 4.246 0 4.498c0 .251.219.458.494.458h11.805L8.722 8.22a.435.435 0 000 .645c.197.18.515.18.705 0l4.425-4.046a.418.418 0 000-.638L9.427.135z"}})])
          )
        }
      }
    